export default {
    namespaced: true,
    state: {
        display: false,
        color: "primary",
        text: ""
    },
    getters: {
        snackbar: state => ({
            color: state.color,
            text: state.text,
            display: state.display
        })
    },
    mutations: {
        show(state, payload) {
            state.display = true;
            state.color = payload.color;
            state.text = payload.text;
        },
        hide(state) {
            state.display = false;
            state.color = "primary";
            state.text = "";
        }
    },
    actions: {
        show(context, payload) {
            context.commit("show", payload)
        },
        hide(context) {
            context.commit("hide")
        }
    }
}